<template>
    <div>
        <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.privacy-section-14 class="text-left fw-500">14. Miscellaneous Provisions</b-button>
            </b-card-header>
            <b-collapse id="privacy-section-14" visible accordion="my-accordion" role="tabpanel">
                <b-card-body>
                    <ol>
                        <li>Severability: If any provision of these terms is found to be invalid or unenforceable, the remaining provisions will continue in full force and effect.</li>
                        <li>Entire Agreement: These terms constitute the entire agreement between the Account Holder and RCPAY Virtual Account regarding the VA service.</li>
                        <li>No Waiver: Failure by RCPAY Virtual Account to enforce any right or provision of these terms will not constitute a waiver of such right or provision.</li>
                        <li>Notices: Any notices or communications required or permitted under these terms shall be in writing and shall be deemed to have been duly given via email to the registered email address of the respective party.</li>
                        <li>Assignment: The Account Holder may not transfer or assign any of their rights or obligations under these terms without the prior written consent of RCPAY Virtual Account.</li>
                    </ol>
                </b-card-body>
            </b-collapse>
        </b-card>
      
    </div>
</template>

<script>
  
export default {
    name: 'section-14',
    data() {
        return {
        publicPath      : process.env.BASE_URL!='/'?process.env.BASE_URL:''
        };
    }
};
</script>